<template>
  <modal :value="value"
         max-width="500"
         @input="emitInput">

    <div class="voucher-segment-client-generate-modal-body">
      <app-form class="voucher-segment-client-generate-modal-body-form"
                ref="voucherForm"
                @submit="generateVoucherClient">
        <h1 class="text-muted text-center">
          Gerar Vouchers
        </h1>

        <text-field class="marketing-automation-create-name"
                    v-model="form.comment"
                    label="Comentário"
                    name="Comentário"
                    validate="required" />

        <text-field class="marketing-automation-create-name"
                    v-model="form.useCounter"
                    label="Quantidade de usos"
                    name="Quantidade de usos"
                    help="Caso não seja inserido um valor, a quantidade de usos será ilimitada" />

        <checkbox v-model="hasExpirationDate"
                  label="Adicionar data de expiração"
                  class="expiration-date-checkbox"
                  hideDetails/>

        <app-box-wrapper v-if="hasExpirationDate"
                        data-label="Data de Expiração"
                        data-icon="mdi-calendar-range">

            <app-date-picker v-model="form.expirationDate"
                            menu-width="auto"></app-date-picker>

        </app-box-wrapper>

        <dropzone v-model="form.file"
                  name="Arquivo"
                  ref="dropzone"
                  :shouldResetInput="shouldResetInput"/>

      </app-form>
    </div>

    <template v-slot:footer>
      <app-button class="voucher-segment-client-generate-modal-body-form-action btn btn-primary"
                  :label="$t('message.generics.message.add')"
                  type="submit"
                  flat
                  primary
                  @click="forceSubmit">
      </app-button>
    </template>

  </modal>
</template>

<script>
import Dropzone from "@components/form/Dropzone.vue";
import AppForm from "@components/form/Form.vue";
import TextField from "@components/form/TextField.vue";
import Modal from "@/components/generic/Modal";
import AppButton from "@/components/generic/button/Button";
import EventBus from "@packages/event-bus/index";
import AppBoxWrapper from "@components/BoxWrapper";
import AppDatePicker from "@components/DatePicker";
import Checkbox from "@components/Checkbox";

export default {
  components: {
    Modal,
    TextField,
    AppForm,
    AppButton,
    Dropzone,
    AppBoxWrapper,
    AppDatePicker,
    Checkbox
  },

  data() {
    return {
      infiniteId: +new Date(),
      form: {
        comment: undefined,
        useCounter: "",
        file: undefined,
        expirationDate: new Date().toISOString().substring(0, 10)
      },
      shouldResetInput: false,
      hasExpirationDate: false
    };
  },

  props: {
    value: {
      type: Boolean,
    },
    segment: {
      type: Object,
      required: true,
    },
  },

  watch: {
    value(showing) {
      if(showing) {
        this.resetValidation();
        this.shouldResetInput = false;
        this.resetData();
      }
    },
    hasExpirationDate(val) {
      if(!val) {
       this.form.expirationDate = new Date().toISOString().substring(0, 10)
      }
    }
  },

  computed: {},

  methods: {
    forceSubmit() {
      this.$refs.voucherForm.submit();
    },
    emitInput(newVal) {
      this.$emit("input", newVal);
      this.shouldResetInput = true
    },
    async generateVoucherClient() {
      try {
        let formData = new FormData();
        formData.append("file", this.form.file);
        formData.append("comment", this.form.comment);
        formData.append("useCounter", this.form.useCounter);
        if(this.hasExpirationDate) formData.append("expirationDate", this.form.expirationDate);

        await this.$api.core.voucher.client.upload({
          formData,
          segmentId: this.segment.id,
        });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: "Vouchers criado com sucesso!",
        });

        this.$emit("created");

        this.emitInput(false);

        this.resetData();

      } catch (error) {
        console.log(error);
      }
    },
    resetData() {
      this.form = {
        comment: undefined,
        useCounter: "",
        file: undefined,
        expirationDate: new Date().toISOString().substring(0, 10)
      }
      this.hasExpirationDate = false
    },
    resetValidation() {
      this.$refs.voucherForm.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
.voucher-segment-client-generate-modal-body {
  .voucher-segment-client-generate-modal-body-form {

    .expiration-date-checkbox {

      ::v-deep .v-input__slot {
        align-items: center;

      }

      ::v-deep .checkbox-label {

        p {
          margin-bottom: 0;
        }
      }

    }

    .box {
      margin-bottom: 10px;

      ::v-deep .dropdown-menu {
        z-index: 11;
      }

    }

  }
}

</style>
